import { AxiosInstance } from 'axios'
import { IJsonApiSerializer } from '../JsonApiSerializer'

class JobService {
  public httpClient: AxiosInstance
  public serializer: IJsonApiSerializer

  constructor(httpClient: AxiosInstance, serializer: IJsonApiSerializer) {
    this.httpClient = httpClient
    this.serializer = serializer
  }

  public async getJobs(params) {
    const { data } = await this.httpClient.get(`/agent/api/weekly/jobs`, { params })
    const jobs = this.serializer.parseResourceData(data.jobs, data.jobs.data)
    const pagination = data.jobs.meta
    const agent_ranks = this.serializer.parseResourceData(data.agent_ranks, data.agent_ranks.data)

    return { jobs, pagination, agent_ranks }
  }

  public async createJob(params) {
    const { data } = await this.httpClient.post(`/agent/api/weekly/jobs`, params)
    const job = this.serializer.parseResourceData(data.job, data.job.data)
    return { job, flush: data.flush }
  }

  public async updateJob(id, params) {
    const { data } = await this.httpClient.patch(`/agent/api/weekly/jobs/${id}`, params)
    const job = this.serializer.parseResourceData(data.job, data.job.data)
    return { job, flush: data.flush }
  }

  public async deleteJob(id: number) {
    const { data } = await this.httpClient.delete(`/agent/api/weekly/jobs/${id}`)

    return { flush: data.flush }
  }

  public async createJobBulkPlan(params) {
    const { data } = await this.httpClient.post(`/agent/api/job_bulk_plans`, params)
    const jobBulkPlan = this.serializer.parseResourceData(
      data.job_bulk_plan,
      data.job_bulk_plan.data
    )
    return { jobBulkPlan, flush: data.flush }
  }

  public async deleteJobBulkPlan(id: number) {
    const { data } = await this.httpClient.delete(`/agent/api/job_bulk_plans/${id}`)
    return { flush: data.flush }
  }
}

export default JobService
